export enum IUserLang {
  ES = "es",

  EN = "en",

  PT = "pt",
}

export interface Social {
  name: string;

  url: string;
}

export interface IUserDB {
  id: number;

  account: string;

  email: string;

  name: string;

  lastName: string;

  cellphone: string;

  avatar: Blob | null;

  lang: IUserLang;

  bio: string;

  socials: object | null;

  profilePublic: boolean;

  username: string;
}

export enum UserType {
  Streamer = "streamer",

  Gamer = "gamer",

  Radio = "radio",

  LiveConcerts = "live_concerts",

  VirtualClasses = "virtual_classes",

  LocalRecording = "local_recording",
}
